export interface ContainerConfigType {
    containerId: string;
    scriptSrc: string;
}

export const getLiveTrackerContainerConfig = (url: string): Record<string, ContainerConfigType> => ({
    americanfootball: {
        containerId: 'the-americanfootball-sport-widget',
        scriptSrc: `${url}/js/theamericanfootballsportwidget.min.js`,
    },
    baseball: {
        containerId: 'the-baseball-sport-widget',
        scriptSrc: `${url}/js/thebaseballsportwidget.min.js`,
    },
    basketball: {
        containerId: 'the-basketball-sport-widget',
        scriptSrc: `${url}/js/thebasketballsportwidget.min.js`,
    },
    cricket: {
        containerId: 'the-cricket-sport-widget',
        scriptSrc: `${url}/js/thecricketsportwidget.min.js`,
    },
    football: {
        containerId: 'the-football-sport-widget',
        scriptSrc: `${url}/js/thefootballsportwidget.min.js`,
    },
    icehockey: {
        containerId: 'the-icehockey-sport-widget',
        scriptSrc: `${url}/js/theicehockeysportwidget.min.js`,
    },
    tennis: {
        containerId: 'the-tennis-sport-widget',
        scriptSrc: `${url}/js/thetennissportwidget.min.js`,
    },
    volleyball: {
        containerId: 'the-volleyball-sport-widget',
        scriptSrc: `${url}/js/thevolleyballsportwidget.min.js`,
    },
});
